
import React, { useRef } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export const WhyAccordion = () => {
    const scollToRef = useRef();

  return (
  
  <div style={{marginTop: '20px', maxWidth: '100%'}}>
<Accordion sx={{border: '1px solid red', maxWidth: '100%'}}
onChange={(event, ex) => {if (ex) {
    setTimeout(() => {scollToRef.current.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      })}, 150)
}}} >
      <AccordionSummary
       ref={scollToRef}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography><b>Why is the criminalisation of sex work harmful?</b></Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography>

        The partial criminalisation of sex work in the U.K. puts sex workers in danger. As more people enter sex work due to the cost of living crisis, fully decriminalising sex work is becoming even more of an urgent necessity. Despite this, the government has taken no action to protect sex workers from the harms of criminalisation, or from the poverty that often leads people to go into sex work.
        <br/><br/>
Criminalisation forces sex workers to work alone indoors, or in more isolated areas on the street, where they're more vulnerable to violence from clients or the police. Many sex workers experience fines or arrests, which push them further into poverty and so trap them in sex work.
<br/><br/>
Under the Nordic Model (client criminalisation), which has been implemented in Ireland and Northern Ireland as well as other countries, sex workers are still criminalised. Sex workers who work together for safety risk arrest and prosecution, and even their friends, family members and third parties (such as security or drivers) are also criminalised.
<br/><br/>
It is imperative for sex workers’ safety and human rights that we must bring an end to the current situation of partial criminalisation of sex work in the UK, and also that any attempt to implement the Nordic Model is resisted.
<br/><br/>
Sex workers demand decriminalisation because it is the only regulatory framework surrounding sex work that centres our safety and rights.<br/>
<br/>

<a href="https://decrimnow.org.uk/the-facts/" target="_blank">Read more here.</a>
        </Typography>
      </AccordionDetails>

   
    </Accordion>
    
    </div >
  );
};
